import * as React from 'react';

import { useIntl } from 'react-intl';

import { RecentItemsCarousel } from 'components/recent-items-carousel';
import { useEffectOnce } from 'hooks/use-effect-once';
import { useRecentItemsAvailable } from 'hooks/use-recent-items-available';
import { useAuthContext } from 'state/auth';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useLocationContext } from 'state/location';
import { routes } from 'utils/routing';

import {
  MenuRecentItemsInnerWrapper,
  MenuRecentItemsTitle,
  MenuRecentItemsWrapper,
} from './menu-recent-items.styled';

export const MenuRecentItems = () => {
  const { formatMessage } = useIntl();
  const {
    location: { pathname },
  } = useLocationContext();
  const { refreshCurrentUserWithNewSession } = useAuthContext();

  // Make sure the flag is turned ON, the user is at the /menu route and the user has recent items available
  const enableRecentItemsInMenu = useFlag(LaunchDarklyFlag.ENABLE_RECENT_ITEMS_IN_MENU);
  const isAtTheMainMenu = pathname === routes.menu;
  const recentItemsAvailable = useRecentItemsAvailable();
  const enableDirectAccessToMenu = useFlag(LaunchDarklyFlag.ENABLE_DIRECT_ACCESS_TO_MENU);

  useEffectOnce(() => {
    refreshCurrentUserWithNewSession();
  });

  const showMenuRecentItems =
    enableRecentItemsInMenu &&
    recentItemsAvailable &&
    isAtTheMainMenu &&
    // When direct access to menu and recent items flags are enabled, the recent items are displayed in a separate section
    !enableDirectAccessToMenu;

  return showMenuRecentItems ? (
    <MenuRecentItemsWrapper data-testid="menu-recent-items">
      <MenuRecentItemsInnerWrapper>
        <MenuRecentItemsTitle>{formatMessage({ id: 'recentItems' })}</MenuRecentItemsTitle>
        <RecentItemsCarousel containerHasTopPadding={false} locationName="Menu" />
      </MenuRecentItemsInnerWrapper>
    </MenuRecentItemsWrapper>
  ) : null;
};
